import script from "./SummaryRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./SummaryRow.vue?vue&type=script&setup=true&lang=ts"

import "./SummaryRow.vue?vue&type=style&index=0&id=53530e1b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53530e1b"]])

export default __exports__